import { useRootStore } from 'stores/RootStore'
import { useCurrentWorkspace } from './useCurrentWorkspace'
import { PaymentPlanKey } from 'api/clients/PaymentPlanClient'

export interface AutopilotLimits {
  maxChannels: number
  maxPostsPerChannel: number
  maxAccounts: number
  disabledChannels: string[]
}

type Props = {
  forcePlan?: PaymentPlanKey
}

export const FREE_REFERRAL_TIERS = [0, 1, 3, 6, 10]
export const FREE_REWARD_TIERS = [1, 2, 3, 4, 5]

export const STARTER_LIMITS: AutopilotLimits = {
  maxChannels: Infinity,
  maxPostsPerChannel: 100,
  maxAccounts: 3,
  disabledChannels: [],
}

export const GROWTH_LIMITS: AutopilotLimits = {
  maxChannels: Infinity,
  maxPostsPerChannel: 100,
  maxAccounts: 10,
  disabledChannels: [],
}

export const DEFAULT_LIMITS: AutopilotLimits = {
  maxChannels: Infinity,
  maxPostsPerChannel: 15,
  maxAccounts: Infinity,
  disabledChannels: [],
}

const calculateFreeRewardAmount = (count: number): number => {
  if (count >= 10) return FREE_REWARD_TIERS[4]
  if (count >= 6) return FREE_REWARD_TIERS[3]
  if (count >= 3) return FREE_REWARD_TIERS[2]
  if (count >= 1) return FREE_REWARD_TIERS[1]
  return FREE_REWARD_TIERS[0]
}

export const useAutopilotLimits = (props?: Props): AutopilotLimits => {
  const { forcePlan } = props || {}

  const workspace = useCurrentWorkspace()
  const tierUsageStore = useRootStore().tierUsageStore
  const { currentSubscription } = tierUsageStore

  const isOnStarterPlan = currentSubscription?.plan === PaymentPlanKey.BlazeAutopilotStarter
  const isOnGrowthPlan = currentSubscription?.plan === PaymentPlanKey.BlazeAutopilotGrowth

  if ((!forcePlan && workspace?.is_ap_freemium) || forcePlan === PaymentPlanKey.Free) {
    const rewardAmount = calculateFreeRewardAmount(workspace?.referral_rewards?.free || 0)

    return {
      maxChannels: 3,
      maxPostsPerChannel: rewardAmount,
      maxAccounts: 3,
      disabledChannels: ['crosspost_contents', 'video_crosspost_contents'],
    }
  }

  if ((!forcePlan && isOnStarterPlan) || forcePlan === PaymentPlanKey.BlazeAutopilotStarter) {
    return STARTER_LIMITS
  }

  if ((!forcePlan && isOnGrowthPlan) || forcePlan === PaymentPlanKey.BlazeAutopilotGrowth) {
    return GROWTH_LIMITS
  }

  return DEFAULT_LIMITS
}
